// extracted by mini-css-extract-plugin
module.exports = {"calendargroup":"CalendarGroup_calendargroup__tGdxb","calendargroup-items":"CalendarGroup_calendargroup-items__jXMrX"};